import React from 'react'
import { Link } from 'react-router-dom'
import datesIcon from 'assets/img/icons/empty-date-packs.svg';
import categoriesIcon from 'assets/img/icons/empty-categories.svg';
import eventsIcon from 'assets/img/icons/empty-events.svg';
import triggersIcon from 'assets/img/icons/empty-triggers.svg';
import prizesIcon from 'assets/img/icons/empty-prizes.svg';

const EmptyBlockSecondary = ({ type }) => {

  const getData = () => {
    switch (type) {
      case 'dates':
        return {
          icon: datesIcon,
          text: 'No date cards',
        }
      case 'categories':
        return {
          icon: categoriesIcon,
          text: 'No category cards',
        }
      case 'events':
        return {
          icon: eventsIcon,
          text: 'No event cards',
        }
      case 'triggers':
        return {
          icon: triggersIcon,
          text: 'No trigger cards'
        }
      case 'prizes':
        return {
          icon: prizesIcon,
          text: 'No prize cards'
        }
      case 'predictions':
        return {
          icon: prizesIcon,
          text: 'No prize cards'
        }
      default:
        break;
    }
  }

  return (
    <div className="empty-packs">
      <img src={getData().icon} className="empty-packs__pic" alt="" />
      <h2 className="empty-packs__title">{getData().text}</h2>
      <footer className="empty-packs__links">
        <Link to="/buypacks" className="empty-packs__link">Buy Packs</Link>
        <Link to="/marketplace/cards" className="empty-packs__link">Buy Cards</Link>
      </footer>
    </div>
  )
}

export default EmptyBlockSecondary;
